import { Rating, Theme } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import { memo } from 'react'
import BankLogo from './BankLogo'
import { IBankLogoContainer, IImgColor } from './typings'

const useStyles = makeStyles<Theme, { isRowExpanded: boolean }>(
  (theme: Theme) =>
    createStyles({
      responsiveLogoRating: {
        display: 'grid',
        gridAutoFlow: 'row',
        alignItems: 'center',
        order: -2,
        margin: 10,
        [theme.breakpoints.up('lg')]: {
          gridAutoFlow: 'column',
          padding: 10,
        },
      },
      ratingStyles: {
        marginLeft: 50,
        [theme.breakpoints.down('lg')]: {
          marginLeft: 0,
        },
      },
    }),
)

const BankLogoWithRating = ({
  imageSources,
  isRowExpanded,
  recommendationRate,
}: IBankLogoContainer) => {
  const { responsiveLogoRating, ratingStyles } = useStyles({ isRowExpanded })
  const logoSrc = {
    [IImgColor.COLOR]: imageSources.colorSVG,
    [IImgColor.GREY]: imageSources.graySVG,
  }

  return (
    <div className={responsiveLogoRating}>
      <BankLogo logoSrc={logoSrc} />
      <Rating
        className={ratingStyles}
        value={recommendationRate * 5}
        precision={0.1}
        readOnly
      />
    </div>
  )
}

export default memo(BankLogoWithRating)
